import { createSlice } from '@reduxjs/toolkit';
import { loadAppState } from '../../utils/storage';

const persistedState = loadAppState();

const appSlice = createSlice({
  name: 'app',
  initialState: persistedState.app,
  reducers: {
    initializeApp: (state) => state,
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    toggleTheme: (state) => {
      if (state.theme === 'system') {
        const prefersDark =
          typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches;
        state.theme = prefersDark ? 'light' : 'dark';
        return;
      }
      state.theme = state.theme === 'light' ? 'dark' : 'light';
    }
  }
});

export const { initializeApp, setLanguage, setTheme, toggleTheme } = appSlice.actions;
export const selectDirection = (state) => (state.app.language === 'fa' ? 'rtl' : 'ltr');
export const selectTheme = (state) => state.app.theme;
export const selectResolvedTheme = (state) => {
  const theme = state.app.theme;
  if (theme !== 'system') {
    return theme === 'dark' ? 'dark' : 'light';
  }
  if (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
};
export default appSlice.reducer;
